<template>
    <section v-if="results.length" class="search">
        <div class="container">
            <h3 class="search-result__title">Search results</h3>
            <div class="search-result__item">
                <div class="search-result-content">
                    <img :src="thumb" alt="" class="search-result__item-img" />

                    <div class="search-result-mainPlay">
                        <img src="/img/result/play.svg" class="" alt="" />
                    </div>
                    <div class="search-result-views">
                        <img src="/img/result/views.svg" class="" alt="" />
                        <span> 721,3k </span>
                    </div>
                </div>
                <div class="search-result__item-info">
                    <div class="search-result__item-info-table">
                        <div class="search-result-download-head search__result-head quality">
                            <div class="search__result-download-head-quality search-result__item-info-table-item-title search__result-quality">quality</div>
                            <div class="search__result-download-head-quality search-result__item-info-table-item-title search__result-quality">size</div>
                            <div class="search__result-download-head-quality search-result__item-info-table-item-title search__result-download">download</div>
                        </div>
                        <div class="search-result-download-main search__result-main">
                            <!-- Loop through results dynamically -->
                            <div
                                v-for="(result, index) in results"
                                :key="index"
                                class="search-result-download-main-item search__result-main-item"
                            >
                                <div class="search-result-download-main-quality search__result-quality">
                                    <span>{{ result.ext.toUpperCase() }} {{ getQualityLabel(result) }}</span>
                                    <img
                                        v-if="result.with_watermark"
                                        src="/img/watermark.svg"
                                        alt="Watermark Icon"
                                        class="custom-svg-img"
                                    />
                                </div>
                                <div class="search-result__item-info-table-item-info search__result-quality">
                                    <span v-if="result.size">{{ bytesToMB(result.size) }} MB</span>
                                    <span v-else>- MB</span>
                                </div>
                                <div class="search-result__item-info-table-item-info search__result-button">
                                    <button v-bind:class="[result.ext === 'mp4' ? 'result__btn_alt' : '', 'result__btn']" @click="downloadItem(result)">
                                        <a :href="result.url" download>Download</a>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="search-result-texts">
                        <p class="search-result__item-info-author search-result-author">{{ username }}</p>
                        <p class="search-result__item-info-author search-result-text">{{ title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import experimentHooks from "../experiment/experimentHooks";

export default {
    name: "SearchResult",
    data() {
        return {
            thumb: null,
            title: null,
            username: null,
            results: []
        };
    },
    created() {
        this.$root.$on('tt-result-received', (data) => {
            const userNameMatch = data?.meta?.source.match(/(?<=com\/)\@[^\/]+/);
            this.thumb = data?.thumb || null;
            this.title = data?.meta?.title || null;
            this.username = userNameMatch ? userNameMatch[0] : '';
            this.results = data.url;
        });
        this.$root.$on('clear-results', this.clearResults);
    },
    beforeDestroy() {
        this.$root.$off('tt-result-received', this.handleResultReceived);
        this.$root.$off('clear-results', this.clearResults);
    },
    methods: {
        clearResults() {
            this.thumb = null;
            this.title = null;
            this.username = null;
            this.results = [];
        },
        downloadItem(result) {
            this.$root.$emit('download-click', result.ext);
        },
        bytesToMB(bytes) {
            return (bytes / (1024 * 1024)).toFixed(2);
        },
        getQualityLabel(result) {
            if (result.ext === 'mp3') {
                return '';
            } else if (result.ext === 'mp4') {
                if (result.subname === '540') {
                    return '(SD)';
                } else if (result.subname === '720') {
                    return '(HD)';
                }
            }
            return `(${result.subname || 'N/A'})`;
        }
    }
};
</script>
